import React from "react";

const IsopureHeader = () => {
  return (
    <div>
      {" "}
      <section
        id="topbar"
        className="topbar d-flex align-items-center green-gradient "
      >
        <div className="container-fluid d-flex justify-content-center justify-content-md-between mobile-view">
          <div className="contact-info d-flex align-items-center contacte ">
            <i className="fa fa-envelope d-flex align-items-center text-white">
              <a href="mailto:indiacustomercare@glanbia.com" target="_blank">
                &nbsp;indiacustomercare@glanbia.com
              </a>
            </i>
            <i className="fa fa-phone d-flex align-items-center text-white">
              <a href="tel:01149594959" target="_blank">
                &nbsp;011 - 49594959
              </a>
            </i>
          </div>
          {/* <div className="social social-links d-none d-md-flex align-items-center mr-3">
            <a href="https://twitter.com/OptimumNutri_IN" className="twitter">
              <i className="fa fa-twitter" />
            </a>
            <a
              href="https://www.facebook.com/OptimumNutritionIN"
              className="facebook"
            >
              <i className="fa fa-facebook" />
            </a>
            <a
              href="https://www.instagram.com/optimumnutri_in/"
              className="instagram"
            >
              <i className="fa fa-instagram" />
            </a>
            <a
              href="https://www.youtube.com/user/OptimumNutriIN"
              className="youtube"
            >
              <i className="fa fa-youtube" />
            </a>
          </div> */}
        </div>
      </section>
    </div>
  );
};

export default IsopureHeader;
